package com.royceecoleman.bill.pages

import androidx.compose.runtime.Composable
import com.royceecoleman.bill.auth.loginActionUrl
import com.varabyte.kobweb.core.Page
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Form
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Main
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Page
@Composable
fun loginPage() {
    val hasInvalidCredentialsError = window.location.search.contains("error=invalid-credentials")
    val hasTooManyAttemptsError = window.location.search.contains("error=too-many-attempts")
    val hasRegistrationSuccess = window.location.search.contains("registered=true")

    Main(
        attrs = {
            style {
                property("min-height", "100vh")
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
                property("padding", "1.5rem")
                property("background", "#0f172a")
                property(
                    "font-family",
                    "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                )
            }
        },
    ) {
        Div(
            attrs = {
                style {
                    property("width", "min(28rem, 100%)")
                    property("padding", "2rem")
                    property("border-radius", "1rem")
                    property("background", "rgba(255, 255, 255, 0.97)")
                    property("box-shadow", "0 24px 60px rgba(15, 23, 42, 0.35)")
                }
            },
        ) {
            H1(
                attrs = {
                    style {
                        property("margin", "0")
                        property("font-size", "2rem")
                    }
                },
            ) {
                Text("Login")
            }
            if (hasInvalidCredentialsError || hasTooManyAttemptsError) {
                P(
                    attrs = {
                        style {
                            property("margin", "1rem 0 0")
                            property("padding", "0.85rem 1rem")
                            property("border-radius", "0.75rem")
                            property("background", "#fee2e2")
                            property("color", "#b91c1c")
                        }
                    },
                ) {
                    Text(
                        if (hasTooManyAttemptsError) {
                            "Too many failed sign-in attempts. Wait 15 minutes and try again."
                        } else {
                            "Invalid username or password. Try again."
                        },
                    )
                }
            }
            if (hasRegistrationSuccess) {
                P(
                    attrs = {
                        style {
                            property("margin", "1rem 0 0")
                            property("padding", "0.85rem 1rem")
                            property("border-radius", "0.75rem")
                            property("background", "#dcfce7")
                            property("color", "#166534")
                        }
                    },
                ) {
                    Text("Account created. Please sign in.")
                }
            }

            Form(
                attrs = {
                    attr("action", loginActionUrl())
                    attr("method", "post")
                    style {
                        property("display", "grid")
                        property("gap", "1rem")
                        property("margin-top", "1.5rem")
                    }
                },
            ) {
                Div {
                    Label(
                        forId = "username",
                        attrs = {
                            style {
                                property("display", "block")
                                property("font-weight", "600")
                                property("margin-bottom", "0.45rem")
                            }
                        },
                    ) {
                        Text("Username")
                    }
                    Input(
                        type = InputType.Text,
                        attrs = {
                            id("username")
                            attr("name", "username")
                            attr("autocomplete", "username")
                            attr("required", "true")
                            style {
                                property("width", "100%")
                                property("padding", "0.8rem 0.95rem")
                                property("border", "1px solid #cbd5e1")
                                property("border-radius", "0.75rem")
                                property("font-size", "1rem")
                                property("box-sizing", "border-box")
                            }
                        },
                    )
                }

                Div {
                    Label(
                        forId = "password",
                        attrs = {
                            style {
                                property("display", "block")
                                property("font-weight", "600")
                                property("margin-bottom", "0.45rem")
                            }
                        },
                    ) {
                        Text("Password")
                    }
                    Input(
                        type = InputType.Password,
                        attrs = {
                            id("password")
                            attr("name", "password")
                            attr("autocomplete", "current-password")
                            attr("required", "true")
                            style {
                                property("width", "100%")
                                property("padding", "0.8rem 0.95rem")
                                property("border", "1px solid #cbd5e1")
                                property("border-radius", "0.75rem")
                                property("font-size", "1rem")
                                property("box-sizing", "border-box")
                            }
                        },
                    )
                }

                Button(
                    attrs = {
                        attr("type", "submit")
                        style {
                            property("padding", "0.9rem 1rem")
                            property("border", "0")
                            property("border-radius", "0.8rem")
                            property("background", "#2563eb")
                            property("color", "#ffffff")
                            property("font-size", "1rem")
                            property("font-weight", "700")
                            property("cursor", "pointer")
                        }
                    },
                ) {
                    Text("Sign in")
                }
            }
            P(
                attrs = {
                    style {
                        property("margin", "1rem 0 0")
                        property("color", "#475569")
                    }
                },
            ) {
                Text("Need an account? ")
                A(
                    href = "/create-account",
                    attrs = {
                        style {
                            property("color", "#2563eb")
                            property("font-weight", "600")
                        }
                    },
                ) {
                    Text("Create one")
                }
                Text(".")
            }
        }
    }
}
